import React, { lazy, useEffect, useState } from "react";
import { Route, Switch } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Navbar from "@src/views/Ushno/Navbar";
import Footer from "@src/views/Ushno/Footer";
import Website from "@src/views/Ushno/home/Home";
import About from "@src/views/Ushno/about/About";
import Show from "@src/views/Ushno/schedule/Show";
import Contact from "@src/views/Ushno/contact/Contact";
import Team from "@src/views/Ushno/team/Team";
import Photos from "@src/views/Ushno/gallery/photos";
import PhotoById from "@src/views/Ushno/gallery/photos/PhotoById";
import GalleryByUser from "@src/views/Ushno/gallery/photos/galleryByUser";
import Videos from "@src/views/Ushno/gallery/videos";
import VideoById from "@src/views/Ushno/gallery/videos/VideoById";
import Podcasts from "@src/views/Ushno/podcast";
import PodcastById from "@src/views/Ushno/podcast/PodcastById";
import Sponsor from "@src/views/Ushno/sponsor/Sponsor";
import ListTopic from "@src/views/Ushno/dataNews";
import TopicById from "@src/views/Ushno/dataNews/DetailsDataNews";
import TopicByUserId from "@src/views/Ushno/dataNews/topicByUser";
import Emissions from "@src/views/Ushno/emissions/";
import EmissionById from "@src/views/Ushno/emissions/EmissionById";
import EmissionsByCategory from "@src/views/Ushno/emissions/emissionByCategory";
import EmissionByTag from "@src/views/Ushno/emissions/emissionByTag";
import EmissionByClassification from "@src/views/Ushno/emissions/EmissionByClassification";
import EpisodesByTag from "@src/views/Ushno/Episodes/EpisodesByTag";
import EpisodesByCategory from "@src/views/Ushno/Episodes/EpisodesByCategory";
import EpisodesByClassification from "@src/views/Ushno/Episodes/EpisodesByClassification";
import Playlists from "@src/views/Ushno/playlist";
import playlistByCategory from "@src/views/Ushno/playlist/playlistByCategory/playlistByCategory";
import PlaylistById from "@src/views/Ushno/playlist/PlaylistById";
import AudioPlayer from "@src/views/audio_player";
import weatherwidgets from "@src/views/Ushno/widgets/weatherWidgets";
import MoneyConvertwidgets from "@src/views/Ushno/widgets/MoneyConvertWidgets";
import Holydayswidgets from "@src/views/Ushno/widgets/HolydaysWidgets";
import Horoscopeswidgets from "@src/views/Ushno/widgets/HoroscopWidgets";
import VoteContainer from "@src/views/Ushno/widgets/Vote/VoteContainer";
import QuestionLisByid from "@src/views/Ushno/widgets/Vote/QuestionListByid";
import Publicity from "@src/views/TuneIn/pub";
import QuizList from "@src/views/Ushno/widgets/quiz/quizlist/QuizList";
import QuizItem from "@src/views/Ushno/widgets/quiz/quizItem/QuizItem";
import { useBgColor } from "@hooks/useBgColor";
import "@src/views/audio_player/tuneIn.scss";
import "@src/views/Ushno/playerUshno/css/full_player.css";

const FrontOfficeRoute = () => {
  const { setBgColor } = useBgColor();
  const RadioReducer = useSelector((state) => state.RadioReducer);
  const Error = lazy(() => import("@src/views/ErrorLight"));
  const plyr__videowrapper = document.getElementsByClassName(
    "plyr__video-wrapper"
  );
  const [isloadind, setIsloadind] = useState(false);
  const [playerPause, setPlayerPause] = useState(true);
  const isPaused = () => {
    setPlayerPause(true);
  };
  const isPlayed = () => {
    setPlayerPause(false);
  };
  const onpenVideoPlayer = (x) => {
    for (var i = 0; i < plyr__videowrapper.length; i++) {
      plyr__videowrapper[i].style.display = x;
    }
  };
  const onpenVideoFullScreen = (x) => {
    for (var i = 0; i < plyr__videowrapper.length; i++) {
      plyr__videowrapper[i].style.top = x;
    }
  };

  // For sticky navbar UI
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.pageYOffset > 80) {
        $(".navbar-part").addClass("navbar-fixed");
        $(".player-navbar-part").addClass("player-sticky");
        $(".player-navbar-part").addClass("player-sticky-size");
      }
      if (window.pageYOffset < 80) {
        $(".navbar-part").removeClass("navbar-fixed");
        $(".player-navbar-part").removeClass("player-sticky");
        $(".player-navbar-part").removeClass("player-sticky-size");
      }
    });
  }, []);
  useEffect(() => {
    document.body.removeAttribute("class");
    setBgColor("white");
  }, []);

  return (
    <div className="Ushno">
      <Navbar
        playerPause={playerPause}
        isPaused={isPaused}
        isPlayed={isPlayed}
        isloadind={isloadind}
        setIsloadind={setIsloadind}
        RadioReducer={RadioReducer}
      />

      <Switch>
        <Route path="/" exact render={() => <Website />} />
        <Route path="/about-us" exact component={About} />
        <Route exact path="/contact-us" component={Contact} />
        <Route
          exact
          path="/dataNews/:webmasterTitle/topics"
          component={ListTopic}
        />
        <Route
          exact
          path="/dataNews/:webmasterTitle/topics/:id"
          component={TopicById}
        />
        <Route
          exact
          path="/dataNews/:webmasterTitle/topics/created_by/:user_id"
          component={TopicByUserId}
        />
        <Route exact path="/emission/:id" component={EmissionById} />
        <Route exact path="/podcast/:id" component={PodcastById} />
        <Route exact path="/Gallery/Photos/topics" component={Photos} />
        <Route exact path="/Gallery/Photos/topics/:id" component={PhotoById} />
        <Route
          exact
          path="/Gallery/Photos/topics/created_by/:user_id"
          component={GalleryByUser}
        />
        <Route exact path="/schedule" component={Show} />
        <Route exact path="/team" component={Team} />
        <Route exact path="/emissions" component={Emissions} />
        <Route
          exact
          path="/emissions/category/:slug"
          component={EmissionsByCategory}
        />
        <Route exact path="/emissions/tag/:slug" component={EmissionByTag} />
        <Route
          exact
          path="/emissions/classification/:slug"
          component={EmissionByClassification}
        />
        <Route exact path="/episode/tag/:slug" component={EpisodesByTag} />
        <Route
          exact
          path="/episode/category/:slug"
          component={EpisodesByCategory}
        />
        <Route
          exact
          path="/episode/classification/:slug"
          component={EpisodesByClassification}
        />
        <Route exact path="/sponsor" component={Sponsor} />
        <Route exact path="/Gallery/Videos/topics" component={Videos} />
        <Route exact path="/Gallery/Video/:id" component={VideoById} />
        <Route exact path="/podcast" component={Podcasts} />
        <Route exact path="/playlists" component={Playlists} />
        <Route
          exact
          path="/playlists/category/:id"
          component={playlistByCategory}
        />
        <Route exact path="/playlist/:id" component={PlaylistById} />
        <Route exact path="/widgets/weather/:id" component={weatherwidgets} />
        <Route exact path="/widgets/vote/:id" component={VoteContainer} />
        <Route
          exact
          path={"/widgets/holydays/:id"}
          component={Holydayswidgets}
        />
        <Route
          exact
          path={"/widgets/moneyConvert/:id"}
          component={MoneyConvertwidgets}
        />
        <Route
          exact
          path={"/widgets/horoscope/:id"}
          component={Horoscopeswidgets}
        />
        <Route
          exact
          path={"/vote/question/:vote_id"}
          component={QuestionLisByid}
        />
        <Route exact path={"/Quiz/QuizList"} component={QuizList} />
        <Route exact path={"/Quiz/QuizList/:id"} component={QuizItem} />
        <Route path="*" component={Error} />
      </Switch>
      <div className="TuneIn">
        <div className="footerUshno">
          <Footer />
        </div>
        <div className="adsPlayerTunein">
          <Publicity />
        </div>
        <AudioPlayer
          onpenVideoPlayer={onpenVideoPlayer}
          onpenVideoFullScreen={onpenVideoFullScreen}
          playerPause={playerPause}
          isPaused={isPaused}
          isPlayed={isPlayed}
          isloadind={isloadind}
          setIsloadind={setIsloadind}
          RadioReducer={RadioReducer}
        />
      </div>
    </div>
  );
};

export default FrontOfficeRoute;
